import React from 'react';

import MUIDataTable from 'mui-datatables';

import TableFooter from './TableFooter';

export default React.forwardRef(({ columns, data, options, className }, ref) => {
  return (
    <MUIDataTable
      ref={ref}
      style={{ boxShadow: 'none' }}
      columns={columns}
      data={data}
      className={className}
      options={{
        customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
          return <TableFooter count={count} page={page} rowsPerPage={rowsPerPage} changePage={changePage} />;
        },
        download: false,
        filter: false,
        print: false,
        responsive: 'standard',
        search: false,
        selectToolbarPlacement: 'none',
        selectableRows: 'single',
        selectableRowsHeader: false,
        selectableRowsHideCheckboxes: true,
        selectableRowsOnClick: true,
        sort: false,
        viewColumns: false,
        ...options,
      }}
    />
  );
});
